import React from "react";
import { Trophy } from "lucide-react";

const LeagueFilterRail = ({
  leagues,
  selectedId,
  onSelect,
  totalMatches,
  loading = false,
}) => (
  <aside className="pcr-leagues" aria-label="Filter by league">
    <p className="pcr-leagues-label">Leagues</p>

    <div className="pcr-leagues-list" role="tablist" aria-label="Leagues">
      <button
        type="button"
        role="tab"
        aria-selected={selectedId === null}
        className={`pcr-league-btn pcr-league-btn-all${selectedId === null ? " pcr-league-btn-on" : ""}`}
        onClick={() => onSelect(null)}
        disabled={loading}
      >
        <span className="pcr-league-btn-icon pcr-league-btn-icon-all">
          <Trophy size={14} />
        </span>
        <span className="pcr-league-btn-copy">
          <span className="pcr-league-btn-name">All leagues</span>
          <span className="pcr-league-btn-sub">Every upcoming match</span>
        </span>
        <span className="pcr-league-btn-count">{totalMatches}</span>
      </button>

      {leagues.map((league) => (
        <button
          key={league.id}
          type="button"
          role="tab"
          aria-selected={selectedId === league.id}
          className={`pcr-league-btn${selectedId === league.id ? " pcr-league-btn-on" : ""}`}
          onClick={() => onSelect(league.id)}
        >
          <span className="pcr-league-btn-icon">
            {league.logo ? (
              <img src={league.logo} alt="" />
            ) : (
              <Trophy size={14} />
            )}
          </span>
          <span className="pcr-league-btn-copy">
            <span className="pcr-league-btn-name">{league.name}</span>
            <span className="pcr-league-btn-sub">{league.country || "Unknown"}</span>
          </span>
          <span className="pcr-league-btn-count">{league.count}</span>
        </button>
      ))}
    </div>
  </aside>
);

export default LeagueFilterRail;
